import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stories-grid',
  templateUrl: './stories-grid.component.html',
  styleUrls: ['./stories-grid.component.css']
})
export class StoriesGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
